import { render, staticRenderFns } from "./AdRevenueQuery.vue?vue&type=template&id=65b38294&scoped=true"
import script from "./AdRevenueQuery.vue?vue&type=script&lang=js"
export * from "./AdRevenueQuery.vue?vue&type=script&lang=js"
import style0 from "./AdRevenueQuery.vue?vue&type=style&index=0&id=65b38294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b38294",
  null
  
)

export default component.exports